
import React, { useState } from "react";
import TitleDescription from "../../../components/newMotorPolicy/titleDescription/titleDescription";
import { useTranslation } from "react-i18next";
import RenewMotorLayout from "../renewalMotorPolicy/renewMotorLayout";
import FileUpload from "../../../components/common/fileUploadInput/fileUploadInput";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useMotorForm from "../../../hooks/useMotorFormData";
import { useDispatch, useSelector } from "react-redux";
import { RemoveBank } from "../../../redux/features/motor/RemoveBankSlice";
import FileUploadClaimHistory from "../../../components/common/fileUploadInput/fileUploadClaimHistory";
import CryptoJS from "crypto-js";
import Input from "../../../components/common/Input/Input";
import { BASE_URL } from "../../../api/baseURL";
export const REMOVEBANKNAME_UPLOAD_BANK_NOC = "REMOVEBANKNAME_UPLOAD_BANK_NOC";

const UploadClaimHistory = ({ switchToggle, PolicyNo, Bank }) => {
  const [formData, setFormData] = useState({ bankNOC: null });
  const [PolicyNumber, setPolicyNumber] = useState(PolicyNo);
  const [Value, setValue] = useState(Bank);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encryptedClaim = queryParams.get("claimtype");
  const guid = queryParams.get("id");

  
  const [completedUpload, setCompletedUpload] = useState(false);
  const [isUploadingHistory, setisUploadingHistory] = useState(false);
  const { claim_id } = useParams();
   const secretKey = "i-hate-meej";

   const [iban, setIban] = useState('');
   
   let decryptedType = "";
   try {
     if (encryptedClaim) {
       decryptedType = CryptoJS.AES.decrypt(encryptedClaim, secretKey).toString(CryptoJS.enc.Utf8);
     }
   } catch (e) { decryptedType = ""; }
    // Revert to Base64 format using split and join
    const base64EncryptedValue = (claim_id || "")
      .split("-")
      .join("+") // Replace '-' with '+'
      .split("_")
      .join("/"); // Replace '_' with '/'
  
    // Decrypt the value
    let originalValue = "";
    try {
      if (base64EncryptedValue) {
        const bytes = CryptoJS.AES.decrypt(base64EncryptedValue, secretKey);
        originalValue = bytes.toString(CryptoJS.enc.Utf8);
      }
    } catch (e) { originalValue = ""; }
    const [documentDetails, setDocumentDetails] = useState({
      caseNumber: "",
      Document: "",
      DocumentType: ""
    });
  const BankLetterDetails = useSelector(
    (state) => state.ScanBankLetter.ScannedBank
  );
  const dispatch = useDispatch();
  const removeBankDetails = useSelector(
    (state) => state.RemoveBankName.removeBank
  );
  const removeBankStatus = useSelector((state) => state.RemoveBankName.status);
  const removeBankError = useSelector((state) => state.RemoveBankName.error);

  const { saveMotorDataInRedux } = useMotorForm(
    REMOVEBANKNAME_UPLOAD_BANK_NOC,
    setFormData
  );
  const onFileUploaded = (value, name) => {
    setFormData({ ...formData, [name]: value });
  };

  
  const UpdateDocumentHistory = async () => {
    setisUploadingHistory(true);
    const url = BASE_URL+"/claimcrm/UpdateDocumentHistory";
    const data = {
      guid: guid, // Use the search string here
      Document: documentDetails.Document,
      DocumentType: documentDetails.DocumentType
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        setisUploadingHistory(false);
        throw new Error("Failed to login");
      }

      const result = await response.json();
      setisUploadingHistory(false);
      navigate(-1);
    } catch (error) {
      //toast.error(error.message);
     
      setisUploadingHistory(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  const UpdateIban = async () => {
    setisUploadingHistory(true);
    const url = BASE_URL+"/claimcrm/AddIban";
    const data = {
      caseNumber: originalValue, // Use the search string here
      guid: guid,
      Document: documentDetails.Document,
      Iban: iban
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        setisUploadingHistory(false);
        throw new Error("Failed to login");
      }

      const result = await response.json();
      setisUploadingHistory(false);
      navigate(-1);
    } catch (error) {
      //toast.error(error.message);
     
      setisUploadingHistory(false);
      console.error("Error fetching payment requests:", error);
    }
  };
  const handleChange = (e) => {
    setIban(e.target.value);
  };

  const continueClickHanlder = async () => {
    
    saveMotorDataInRedux(formData);
   
    //await dispatch(RemoveBank(req));
    if(decryptedType == 'IBAN Certification'){
      await UpdateIban();
    }
    else{
      await UpdateDocumentHistory();
    }
    
    //navigate("/motor-insurance/payment-success");
  };
  
  return (
    <RenewMotorLayout
      isUploadingHistory={isUploadingHistory}
      btn_disabled={!completedUpload}
      backClickHandler={switchToggle}
      btn_onClick={continueClickHanlder}
    >
      <div className="max-w-[100%] w-[500px] mx-auto bg-white max767:p-5">
        <TitleDescription
          title={"Upload Required Documents"}
          description={"Please upload the necessary documents to proceed."}
        />
        <div className={`${decryptedType == 'IBAN Certification' ? '' : 'hidden'}`}>
          <Input
            label={decryptedType}
            type="text"
            name="currentPassword"
            value={iban}
            handleChange={handleChange}
          />
        </div>
        <div>
          <p className="mb-3 text-[#48535B] text-base not-italic font-normal leading-[26px] tracking-[-0.16px]">
            Upload {decryptedType}
          </p>
          <FileUploadClaimHistory name="claimHistory" toggleFileUpload={onFileUploaded} setDocumentDetails={setDocumentDetails} caseNumber={originalValue} setCompletedUpload={setCompletedUpload}  />
        </div>
      </div>
    </RenewMotorLayout>
  );
};

export default UploadClaimHistory;
